export default {
  methods: {
    checkExteriorStatus(exteriors, exterior, statuses) {
      const parent = exteriors.find(ext => ext.exterior_id === exterior.parent);
      const relatedOverlay = parent && parent.overlays.find(over => over.linked_exterior_id === exterior.exterior_id);
      const relatedOverlayStatus = relatedOverlay ? statuses.find(status => relatedOverlay.status_id === status.status_id) : null;

      return !exterior.parent || !parent ||
        (!!relatedOverlay && !relatedOverlay.disabled &&
          relatedOverlayStatus.accessible);
    },
    checkExteriorStatusForOverlays(overlay) {
      return !overlay.disabled;
    },
  },
};
